export default class MainMenu {

    static get selector() {
        return '.mainMenu';
    }

    constructor(el) {
        this.el = el;
        this.dropdownItem = this.getDropDown();

        this.setEvents();
    }

    getDropDown() {
        let els = this.el.querySelectorAll('.mainMenu__item--dropdown');
        if(!els) return [];

        let items = []
        els.forEach(el => {
            let item = {}
                item.el = el;
                item.link = el.querySelector('.mainMenu__link');
                item.subMenu = el.querySelector('.mainMenu__subMenu');
                item.isOpen = false;
            items.push(item);
        });

        return items;
    }

    open(item) {
        if(item.isOpen) return;
        item.el.classList.add('mainMenu__item--open');
        item.isOpen = true;
    }


    close(item) {
        if(!item.isOpen) return;
        item.el.classList.remove('mainMenu__item--open');
        item.isOpen = false;
    }

    closeAll() {
        this.items.forEach( item => {
            this.close(item);
        })
    }



    /**
     * Events
     */
    
    setEvents() {
        this.dropdownItem.forEach(item => {
            item.link.addEventListener('click', (e) => { this.e_clickItem(e, item); });
        })
    }

    e_clickItem(e, item) {
        e.preventDefault();
        this.open(item);
    }
}